/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Norwegian (Bokmål)
export default {
  'fabric.elements.share.copied.to.clipboard.message': 'Kobling er kopiert til utklippstavlen',
  'fabric.elements.share.copylink.button.text': 'Kopier kobling',
  'fabric.elements.share.copypubliclink.button.text': 'Kopier offentlig tilgjengelig kobling',
  'fabric.elements.share.failure.icon.label': 'Feil-ikon',
  'fabric.elements.share.failure.message': 'Kan ikke deles',
  'fabric.elements.share.form.comment.label': 'Melding (valgfritt)',
  'fabric.elements.share.form.comment.placeholder': 'Er det noe mottakerne bør vite om dette?',
  'fabric.elements.share.form.info.message.no.invite.confluence': 'Mottakerne vil se navnet på siden og meldingen',
  'fabric.elements.share.form.info.message.no.invite.jira': 'Mottakerne vil se navnet på saken og meldingen',
  'fabric.elements.share.form.info.message.no.invite.jira.issue-term-refresh':
    'Mottakerne vil se navnet på arbeidsoppgaven og meldingen',
  'fabric.elements.share.form.no-permissions': 'Du har ikke muligheten til å dele.',
  'fabric.elements.share.form.public.send': 'Send offentlig tilgjengelig kobling',
  'fabric.elements.share.form.public.share': 'Del offentlig kobling',
  'fabric.elements.share.form.required-field.summary': 'Obligatoriske felt er merket med stjerne',
  'fabric.elements.share.form.retry': 'Prøv igjen',
  'fabric.elements.share.form.send': 'Send',
  'fabric.elements.share.form.share': 'Del',
  'fabric.elements.share.form.title': 'Del',
  'fabric.elements.share.form.user-picker.add-more': 'Legg til mer',
  'fabric.elements.share.form.user-picker.label.confluence': 'Navn, team, grupper eller e-poster',
  'fabric.elements.share.form.user-picker.label.email-disabled-confluence': 'Navn, team eller grupper',
  'fabric.elements.share.form.user-picker.label.email-disabled-jira': 'Navn eller team',
  'fabric.elements.share.form.user-picker.label.email-only': 'E-poster',
  'fabric.elements.share.form.user-picker.label.jira': 'Navn, team eller e-poster',
  'fabric.elements.share.form.user-picker.no-options.existingUserOnly':
    'Vi kunne ikke finne noen resultater for "{inputValue}".',
  'fabric.elements.share.form.user-picker.no-options.generic':
    'Vi kunne ikke finne noen resultater for "{inputValue}". Inviter personer ved å bruke en e-postadresse.',
  'fabric.elements.share.form.user-picker.placeholder.confluence': 'f.eks. Maria, oransje team, gruppe én',
  'fabric.elements.share.form.user-picker.placeholder.email-disabled-jira': 'f.eks. Maria, oransje team',
  'fabric.elements.share.form.user-picker.placeholder.email-only': 'f.eks. maria@company.com',
  'fabric.elements.share.form.user-picker.placeholder.jira': 'f.eks. Maria, oransje team, maria@company.com',
  'fabric.elements.share.form.user-picker.validation.required':
    'Velg minst én bruker, gruppe eller e-post eller minst ett team.',
  'fabric.elements.share.form.user-picker.validation.required-message.confluence':
    'Velg minst én person, gruppe, e-postadresse eller ett team',
  'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-confluence':
    'Velg minst én person, gruppe eller ett team',
  'fabric.elements.share.form.user-picker.validation.required-message.email-disabled-jira':
    'Velg minst én person eller ett team',
  'fabric.elements.share.form.user-picker.validation.required-message.email-only': 'Velg minst én e-postadresse',
  'fabric.elements.share.form.user-picker.validation.required-message.jira':
    'Velg minst én person, gruppe, e-postadresse eller ett team',
  'fabric.elements.share.in.integration.button': 'Del i {integrationName}',
  'fabric.elements.share.invite.to.confluence': 'Inviter til Confluence',
  'fabric.elements.share.invite.to.jira': 'Inviter til Jira',
  'fabric.elements.share.main.tab.text.confluence': 'Del side',
  'fabric.elements.share.main.tab.text.jira': 'Del sak',
  'fabric.elements.share.menu.email.label': 'E-post',
  'fabric.elements.share.menu.slack.label': 'Slack',
  'fabric.elements.share.popup.label': 'Del',
  'fabric.elements.share.success.message':
    '{object, select,blogpost {Blogginnlegg er delt}board {Tavle er delt}calendar {Kalender er delt}draft {Utkast er delt}filter {Filter er delt}issue {Sak er delt}summary {Sammendrag er delt}list {Liste er delt}timeline {Tidslinje er delt}form {Skjema er delt}media {Medier er delt}page {Side er delt}project {Prosjekt er delt}pullrequest {Pull-forespørsel er delt}question {Spørsmål er delt}report {Rapport er delt}repository {Repositorium er delt}request {Forespørsel er delt}roadmap {Veikart er delt}site {Nettsted er delt}space {Område er delt}other {Kobling er delt}}',
  'fabric.elements.share.to.integration.button': 'Del til {integrationName}',
  'fabric.elements.share.trigger.button.icon.label': 'Dele-ikon',
  'fabric.elements.share.trigger.button.invite.text': 'Inviter',
  'fabric.elements.share.trigger.button.text': 'Del',
  'fabric.elements.share.trigger.button.tooltip.text': 'Del',
};
